import React, { useState } from "react";
import ShowAll from "./components/ShowAll/ShowAll";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const BulkUploadProjectWise = (_props: CustomProps) => {
  const [tabValue] = useState<string>("Show All");

  function getContent() {
    switch (tabValue) {
      case "Show All":
        return <ShowAll />;
      default:
        return null;
    }
  }

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      <div className="min-h-0 flex-1">{getContent()}</div>
    </div>
  );
};

export default BulkUploadProjectWise;
